import * as React from 'react';
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="flex justify-center w-full">
      <div
        className="glassmorphism w-full px-6 py-5 border border-[#DEDEDE] rounded-2xl flex justify-between items-center
                   max-lg:flex-col max-lg:items-start max-lg:rounded-none max-lg:mx-0 max-lg:w-full max-lg:px-5
                   lg:mx-20 lg:mt-10 lg:mb-12"
      >
        <a href="/oraclealgo" className="max-lg:self-start">
          <img
            src="/images/oracle-algo.svg"
            alt="Footer Logo"
            className="w-[150px] lg:w-[200px]"
          />
        </a>

        <div
          className="flex flex-wrap items-center gap-x-6 max-lg:gap-y-2 max-lg:mt-3 max-lg:flex-col max-lg:items-start"
        >
          <Link
            to="/legal"
            className="text-white text-opacity-50 font-medium text-base lg:text-sm"
          >
            Terms & Conditions
          </Link>

          <Link
            to="/legal"
            className="text-white text-opacity-50 font-medium text-base lg:text-sm"
          >
            Privacy Policy
          </Link>

          <span
            className="text-white text-opacity-50 font-medium text-base lg:text-sm max-lg:mt-4"
          >
            © Copyright UnityAcademy 2025
          </span>
        </div>
      </div>
    </div>
  );
}

export default Footer;